module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.classes,
    style: ('border-radius: ' + _vm.radius + 'px'),
    on: {
      "click": _vm.onClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e2e9dfa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZButton.vue
// module id = 1098
// module chunks = 0